'use client';
import { useMedia } from './use-media.js';
import { useSettings } from './use-settings.js';
/**
 * Hook to check if the mode is dark
 * @example
 * ```ts
 * import { useIsDarkMode } from "@cloud/shared/ui"
 *
 * const isDarkMode = useIsDarkMode()
 * ```
 */
export function useIsDarkMode() {
    const { settings } = useSettings();
    const isDarkModePreferred = useMedia('(prefers-color-scheme: dark)');
    let resolvedDarkMode = settings.darkMode;
    if (resolvedDarkMode === 'system') {
        resolvedDarkMode = isDarkModePreferred ? 'dark' : 'light';
    }
    return resolvedDarkMode === 'dark';
}
